{
  "unitOfMeasurement": null,
  "scaniaUnits": []
}